import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ElementRef,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { ModalService, CostItemComment, ItemGroupComment, ProjectStatusGuardService } from '@ops/shared-types';
import { TranslateService } from '@ngx-translate/core';
import { ActionMenuOption } from '../action-menu/action-menu.component';

@Component({
  selector: 'ops-comment-popup',
  templateUrl: './comment-popup.component.html',
  styleUrls: ['./comment-popup.component.scss'],
})
export class CommentPopupComponent implements OnInit, OnDestroy {
  private _comments: Array<CostItemComment | ItemGroupComment> = [];

  @Input() id: string;
  @Input() parentId: string;
  @Input() set comments(c: Array<CostItemComment | ItemGroupComment>) {
    this._comments = c;
  }
  get comments(): Array<CostItemComment | ItemGroupComment> {
    return this._comments;
  }

  @Output() saveComment: EventEmitter<CostItemComment | ItemGroupComment> = new EventEmitter();
  @Output() deleteComment: EventEmitter<string> = new EventEmitter();

  private element: any;
  isOpen: boolean = false;
  readonly: boolean = false;
  currentComment: string;
  editCommentId: string;
  shouldEnableOnlyCommentsFeature: boolean = false;
  constructor(
    private modalService: ModalService,
    private el: ElementRef,
    private translateService: TranslateService,
    private projectStatusGuard: ProjectStatusGuardService,
    private cdr: ChangeDetectorRef
  ) {
    this.element = this.el.nativeElement;
    this.element.style.display = 'none';
  }

  ngOnInit(): void {
    if (!this.id) {
      console.error('modal must have an id');
      return;
    }

    if(this.projectStatusGuard.getProjectStatusPrevention()) {
      this.readonly = true;
    }
    if(this.projectStatusGuard.shouldEnableOnlyCommentsFeature(this.projectStatusGuard.getCurrentProject())) {
      this.shouldEnableOnlyCommentsFeature = true;
    }

    this.modalService.add(this);
  }

  ngOnDestroy(): void {
    this.modalService.remove(this.id);
    this.cdr.detach();
    this.element?.remove();
    this.isOpen = false;
  }

  // isFullReadOnly(): boolean {
    
  //   return this.readonly && !this.shouldEnableOnlyCommentsFeature;
  // }

  open(comments: Array<CostItemComment | ItemGroupComment>): void {
    this.comments = comments;
    this.cdr.detectChanges(); 
    if (this.element) {
      this.element.style.display = 'flex';
      // this.element.style.position = 'relative';
      this.isOpen = true;

      // this.element.focus();

      // if (this.element.getElementsByTagName('input')?.length) {
      //   this.element.getElementsByTagName('input')[0].focus();
      // } else if (this.element.getElementsByTagName('textarea')?.length) {
      //   this.element.getElementsByTagName('textarea')[0].focus();
      // }
    }
  }

  close(event?: any): void {
    event?.stopPropagation();
    if (this.element) {
      this.element.style.display = 'none';
      this.isOpen = false;
    }
  }

  openModal(id: string) {
    this.modalService.open(id);
  }
  closeModal(id: string) {
    this.modalService.close(id);
  }

  onTypeComment(event: any) {
    this.currentComment = event.target.value;
    if (event.key === 'Enter' || event.keyCode === 13) {
      this.saveComment.emit({ _id: undefined, text: this.currentComment });
      this.currentComment = '';
      this.comments.sort((a: CostItemComment | ItemGroupComment, b: CostItemComment | ItemGroupComment) => {
        return (b.createdAt?.getTime?.() ?? 0) - (a.createdAt?.getTime() ?? 0);
      });
    }
  }

  onEditComment(event: any, comment: CostItemComment | ItemGroupComment) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      comment.text = event.target.value;
      this.saveComment.emit(comment);
      this.editCommentId = '';
      return;
    }
    if (event.key === 'Escape' || event.keycode == 27) {
      this.editCommentId = '';
    }
  }

  onSelectAction(selection: string, commentId: string) { 
    // console.log('selection', selection);
    // console.log('commentId', commentId);
    switch (selection) {
      case this.translateService.instant('COMMENT_POPUP.DELETE'): {
        this.comments = [...this.comments.filter((c) => c._id != commentId)];
        this.deleteComment.emit(commentId);
        // this.modalService.closeAll()
        // setTimeout(() => , 100)
        return;
      }
      case this.translateService.instant('COMMENT_POPUP.UPDATE'): {
        this.editCommentId = commentId;
        setTimeout(() => {
          document.getElementById('edit' + commentId)?.focus();
        }, 50);

        return;
      }
      default:
        break;
    }
  }

  getOptions(): ActionMenuOption[] {
    return [ 
      {
        label: this.translateService.instant('COMMENT_POPUP.DELETE'),
        value: this.translateService.instant('COMMENT_POPUP.DELETE'),
        isDelete: true,
      },
      {
        label: this.translateService.instant('COMMENT_POPUP.UPDATE'),
        value: this.translateService.instant('COMMENT_POPUP.UPDATE'), 
      },
    ];
  }

  stopPropagation(event: any) {
    event.stopPropagation();
  }
}
